<template>
  <div>
    <div v-if="!loading">
      <TextFormGroup
          :value="value.headline"
          name="headline"
          label="Headline"
          :error="(errors.headline || [])[0]"
          @input="emit('headline', $event)"
      />

      <TextFormGroup
          :value="value.link_text"
          name="link_text"
          label="Link Text"
          :error="(errors.link_text || [])[0]"
          @input="emit('link_text', $event)"
      />

      <TextFormGroup
          :value="value.link_url"
          name="link_url"
          label="Link URL"
          :error="(errors.link_url || [])[0]"
          @input="emit('link_url', $event)"
      />

      <SelectFormGroup
          :value="value.content_article_category_id"
          name="content_article_category_id"
          label="Content Article Category"
          help-text="Filter articles by category."
          :error="(errors.content_article_category_id || [])[0]"
          :options="contentArticleCategoryOptions"
          :nullable="true"
          @input="emit('content_article_category_id', $event)"
      />

      <SelectFormGroup
          :value="value.content_article_label_id"
          name="content_article_label_id"
          label="Content Article Label"
          :error="(errors.content_article_label_id || [])[0]"
          :options="contentArticleLabelOptions"
          :nullable="true"
          @input="emit('content_article_label_id', $event)"
      />

      <RadioFormGroup
          :value="value.context"
          name="context"
          label="Context"
          :error="(errors.context || [])[0]"
          :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
          @input="emit('context', $event)"
      />

      <SelectFormGroup
          :value="value.content_article_flag_id"
          name="content_article_flag_id"
          label="Content Article Flag"
          :error="(errors.content_article_flag_id || [])[0]"
          :options="contentArticleFlagOptions"
          :nullable="true"
          help-text="A flag to put on top when ordering articles in this block."
          @input="emit('content_article_flag_id', $event)"
      />

      <SelectFormGroup
          :value="value.is_editorial"
          name="is_editorial"
          label="Partner Type"
          :error="(errors.is_editorial || [])[0]"
          :options="[{value: '1', label:'Editorial Partner'}, {value: '0', label:'Partner'}]"
          :nullable="true"
          placeholder="All"
          @input="emit('is_editorial', $event)"
      />

      <RadioFormGroup
          :value="value.hide_publish_at"
          name="hide_publish_at"
          label="Hide Publication Date"
          :error="(errors.hide_publish_at || [])[0]"
          :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
          @input="emit('hide_publish_at', $event)"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {RadioFormGroup, SelectFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      contentArticleCategories: null,
      contentArticleLabels: null,
      contentArticleFlags: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    contentArticleCategoryOptions() {
      return this.contentArticleCategories.map(contentArticleCategory => {
        return {value: contentArticleCategory.id, label: contentArticleCategory.attributes.name}
      })
    },

    contentArticleLabelOptions() {
      return this.contentArticleLabels.map(contentArticleLabel => {
        return {value: contentArticleLabel.id, label: contentArticleLabel.attributes.name}
      })
    },

    contentArticleFlagOptions() {
      return this.contentArticleFlags.map(contentArticleFlag => {
        return {value: contentArticleFlag.id, label: contentArticleFlag.attributes.name}
      })
    }
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/content-article-categories', {'filter[portal_id]': this.portal.id}),
        http.get('/api/v2/content-article-labels', {'filter[portal_id]': this.portal.id}),
        http.get('/api/v2/content-article-flags', {'filter[portal_id]': this.portal.id}),
      ]).then(responses => {
        this.contentArticleCategories = responses[0].data.data
        this.contentArticleLabels = responses[1].data.data
        this.contentArticleFlags = responses[2].data.data

        this.loading = false
      })
    },

    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
